import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthorSideBar from '../../components/Layout/AuthorSideBar'
import LoginValidation from '../../yup/Auth/LoginValidation';
import ForgetPasswordModel from '../../components/Model/ForgetPasswordModel';
import Button from '../../components/Ui/Button';
import { useDispatch, useSelector } from 'react-redux';
import { ForgetPasswordAction, UserLoginAction } from '../../redux/Action/AuthAction';
import { getFromStorage, logoutHelper, saveToStorage } from '../../utils/Helper';
import { StorageConstants } from '../../constants/Constants';
import { Config } from '../../config/Config';
import { GetProfileAction } from '../../redux/Action/ProfileAction';
import ApprovalPendingModel from '../../components/Model/ApprovalPendingModel';
import { ImageContainer } from '../../constants/ImagesConstants';
import Errormessages from '../../components/ErrorMessage/Errormessages';
import CommanForm from '../../components/FormController/Commanform';
import { FormattedMessage } from 'react-intl';

import { useIntl } from 'react-intl';
import LanguageSwitcher from '../../components/Layout/LanguageSwitcher';

const Login = () => {
    const intl = useIntl();

    const dispatch = useDispatch<any>();
    const navigate = useNavigate()
    const [showPassword, setShowPassword] = useState(false);
    const userLogin = useSelector((state: any) => state.UserLoginState);
    const profileData = useSelector((state: any) => state.GetProfileState);
    const { register, watch, setValue, errors, handleSubmit } = CommanForm({ validationSchema: LoginValidation, defaultValues: { email: '', password: '' } });

    // handle from submission
    const onSubmit = (payload: any) => {
        dispatch(UserLoginAction(payload))
    }




    /* ******************************** after login ******************************** */
    useEffect(() => {
        if (userLogin?.status) {

            /* Data saved in the storage*/
            saveToStorage({ key: StorageConstants?.IS_USER_LOGIN_TOKEN, value: userLogin?.data?.access_token });
            saveToStorage({ key: StorageConstants?.USER_DETAIL, value: userLogin?.data?.data })
            Config.USER_DETAILS = userLogin?.data?.data
            /* Data saved in the storage*/

            /* remember me functionality */
            if (watch("remember_me") == true) {
                const payload = { email: watch('email'), password: watch('password'), remember_me: watch('remember_me') }
                saveToStorage({ key: StorageConstants?.USER_REMEMBER_ME, value: payload })
            }
            /* remember me functionality */

            /* conditions vise rendering */
            const { is_profile_setup, is_approved, role_id } = userLogin?.data?.data || {};
            Config.IS_USER_LOGIN_TOKEN = userLogin?.data?.access_token;




            // if (userLogin?.data?.data?.role_id == 1 || Config.USER_DETAILS?.role_id == 1) {

            if (is_profile_setup == 0 && is_approved == 0) {
                navigate("/profile");
            }
            else if (is_profile_setup == 1 && is_approved == 0) {
                navigate("/complete-profile");
            }
            else if (is_profile_setup == 2 && is_approved == 0) {
                navigate("/");
            }
            else if (is_profile_setup == 2 && is_approved == 1) {
                // navigate("/dashboard");
                window.location.href = Config?.BASE_URL + "/dashboard"

            }
            else if (is_profile_setup == 2 && is_approved == 2) {
                navigate("/")
            }
            else if (is_profile_setup == 2 && is_approved == 3) {
                navigate("/")
            }
            else if (is_profile_setup == 0 && is_approved == 3) {
                navigate("/profile");
            }
            else if (is_profile_setup == 1 && is_approved == 3) {
                navigate("/complete-profile");
            }

            // else if (userLogin?.data?.data?.role_id == 2 || Config.USER_DETAILS?.role_id == 2) {
            //     window.location.href = Config?.BASE_URL + "/dashboard"
            //     // navigate("/dashboard");
            // }

        }
    }, [userLogin]);


    // Remember me setData functionality
    useEffect(() => {
        const userSession = getFromStorage({ key: StorageConstants?.USER_REMEMBER_ME })
        if (userSession) {
            setValue('email', userSession?.email)
            setValue('password', userSession?.password)
            setValue('remember_me', true)
        }
    }, [])

    // Clear when user move to the next page
    useEffect(() => {
        return () => {
            dispatch(UserLoginAction("RESET"))
        }
    }, []);

    useEffect(() => {
        if (profileData?.data?.data?.is_profile_setup == 0) {
            navigate("/profile")
        }
    }, [profileData]);



    useEffect(() => {
        if (Config?.IS_USER_LOGIN_TOKEN) {
            dispatch(GetProfileAction({}))
        }
    }, [userLogin])



    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const checkUserSession = async () => {
            const token = Config?.IS_USER_LOGIN_TOKEN;
            const profile = Config?.USER_DETAILS?.is_profile_setup;
            const profile_approval = Config?.USER_DETAILS?.is_approved;

            if (token) {
                if (profile == 0 && profile_approval == 0) {
                    navigate("/profile");
                }
                else if (profile == 1 && profile_approval == 0) {
                    navigate("/complete-profile");
                }
                else if (profile == 2 && profile_approval == 0) {
                    navigate("/");
                }
                // Service condition will also be applied
                else if (profile == 2 && profile_approval == 1) {
                    navigate("/service");
                }
                else if (profile == 2 && profile_approval == 1) {
                    navigate("/dashboard");
                }
                else if (profile == 2 && profile_approval == 2) {
                    navigate("/")
                }
                else if (profile == 0 && profile_approval == 3) {
                    navigate("/profile");
                }
                else if (profile == 1 && profile_approval == 3) {
                    navigate("/complete-profile");

                }
                else if (profile == 2 && profile_approval == 3) {
                    navigate("/")
                }
            }
        }

        setIsLoading(false);

        // if (Config?.USER_DETAILS?.is_profile_setup === 1 && token) {
        //     navigate('/complete-profile');
        // }
        // else if (Config?.USER_DETAILS?.is_profile_setup === 2 && token && Config?.USER_DETAILS?.is_approved == 0) {
        //     navigate("/")
        // }
        // else if (Config?.USER_DETAILS?.is_profile_setup === 0 && token && Config?.USER_DETAILS?.is_approved == 3) {
        //     navigate("/profile")
        // }else{
        //     navigate("/login")
        // }
        checkUserSession();
    }, [navigate]);




    useEffect(() => {
        if (Config?.USER_DETAILS?.is_profile_setup == 2) {
            setIsLoading(true);
            navigate("/")
        }
    }, [profileData])




    // useEffect(() => {
    //     const handleStorageChange = (event: StorageEvent) => {

    //         if (event.key == StorageConstants?.IS_USER_LOGIN_TOKEN && event.newValue === null) {
    //             window.location.reload();
    //         }
    //     };

    //     window.addEventListener('storage', handleStorageChange);

    //     return () => {
    //         window.removeEventListener('storage', handleStorageChange);
    //     };
    // }, []);


    if (isLoading) {
        return <>
        </>
    }





    return (
        <>
            <div className='container-fluid p-0'>
                <div className='row g-0'>
                    <div className='col-lg-4 d-none d-lg-block'>
                        <AuthorSideBar />
                    </div>
                    <div className='col-lg-8'>
                        <div className='loginRIght'>
                            <div className='loginTOp text-center text-md-end py-4 d-flex justify-content-between align-items-center px-3 px-md-0'>
                                <LanguageSwitcher className="d-lg-none" variant="dark" />
                                <img alt='logo' src={ImageContainer?.Logo} className="ms-auto" />
                            </div>
                            <h1>  <FormattedMessage id="login" /></h1>
                            <p> <FormattedMessage id="login_to_your_account" /></p>
                            <div className='row mt-5'>
                                <div className='col-lg-6'>
                                    <form onSubmit={handleSubmit(onSubmit)}>

                                        <div className="mb-4 inputIcon">
                                            <label className="form-label">Email*</label>
                                            <input type="text" className="form-control"
                                                placeholder={intl.formatMessage({ id: 'enter_email_address' })}
                                                {...register('email')} />
                                            <span className="iconLeft icon-email"></span>
                                            <Errormessages name="email" errors={errors} />
                                            {/* <ErrorMessage
                                                errors={errors}
                                                name="email"
                                                render={({ message }) => <p className='text-danger'>{message}</p>}
                                            /> */}
                                        </div>

                                        <div className="mb-4 inputIcon">
                                            <label className="form-label"><FormattedMessage id={`password`} />*</label>
                                            <input type={showPassword ? 'text' : 'password'} className="form-control"
                                                placeholder={intl.formatMessage({ id: 'enter_password' })}

                                                {...register('password')} />
                                            <span className="iconLeft icon-lock"></span>
                                            <span className='iconRight viewPassword' onClick={() => setShowPassword(!showPassword)}>
                                                {showPassword ? (
                                                    <img alt='hide' src={ImageContainer?.EyeView} />
                                                ) : (
                                                    <img alt='view' src={ImageContainer?.EyeImage} />
                                                )}
                                            </span>
                                            <Errormessages name="password" errors={errors} />
                                            {/* <ErrorMessage
                                                errors={errors}
                                                name="password"
                                                render={({ message }) => <p className='text-danger'>{message}</p>}
                                            /> */}
                                        </div>


                                        <div className='row'>
                                            <div className="col-6">
                                                <div className='form-check rememberMe'>
                                                    <input type="checkbox" className="form-check-input" id="exampleCheck1"  {...register('remember_me')} />
                                                    <label className="form-check-label" htmlFor="exampleCheck1">{<FormattedMessage id="remember_me" />}</label>
                                                </div>
                                            </div>
                                            <div className='col-6 text-md-end'>
                                                <Link onClick={() => dispatch(ForgetPasswordAction("RESET"))} className='forgotPassword' to='#forgotpassword' data-bs-toggle="modal">{<FormattedMessage id="forgot_password" />}</Link></div>
                                        </div>

                                        <Button type="submit" text={<FormattedMessage id="login" /> as any} className="btn btn-fill w-100 my-5" isLoading={userLogin.loading} />

                                        <p className='notAccount'>
                                            {<FormattedMessage id="Dont_have_an_account" />}
                                            <Link className='fw-600 color-p' to="/register"> {<FormattedMessage id="sign_up" />}</Link>
                                        </p>
                                        <a href="#approval-box" data-bs-toggle="modal" id="approval-model" style={{ display: 'none' }}>Open Modal</a>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ForgetPasswordModel />
            <ApprovalPendingModel />
        </>

    )
}

export default React.memo(Login)
